import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
type BackDropProps = {
  show: boolean;
  setActive: any;
};

const BackDrop: React.FC<BackDropProps> = ({ show, setActive }) => {
  const linkRef = useRef<HTMLAnchorElement>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    if (show) {
      buttonRef.current?.focus();
    }
  }, [show]);

  useEffect(() => {
    if (!show) return;

    function handleKeyDown(e: KeyboardEvent) {
      if (e.key !== "Tab") return;

      const first = buttonRef.current;
      const last = linkRef.current;
      if (!first || !last) return;

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [show]);
  return (
    <div
      className={`unactive_backdrop ${show ? "active" : ""}`}
      role="dialog"
      aria-modal="true"
      aria-labelledby="idle-backdrop-heading"
    >
      <h2 className="h4" id="idle-backdrop-heading">
        Are you still there? <br />
      </h2>
      <div className="ctas">
        <button className="btn btn-primary" onClick={setActive} ref={buttonRef}>
          I'm here
        </button>
        <br />
        <Link to="/" ref={linkRef}>
          Back to Readers
        </Link>
      </div>
    </div>
  );
};

export default BackDrop;
